<div class="container-fluid bg-white rounded pt-4 pb-3">
    <label class="form-label pb-2" *ngIf="mode === 3">{{ "NURSERY_DETAIL_COMPONENT_LABEL" | translate }}</label>
    <label class="form-label pb-2" *ngIf="mode === 2">{{ "NURSERY_ADD_COMPONENT_LABEL" | translate }}</label>
    <label class="form-label pb-2" *ngIf="mode === 1">{{ "NURSERY_EDIT_COMPONENT_LABEL" | translate }}</label>
    <div class="row">
        <img [src]="imageURL" *ngIf="mode === 3 && imageURL !== null" class="col-lg-4 col-md-6 col-12" />
    </div>
    <div class="row">
        <div class="col-xl-8 col-lg-9 col-md-8 col-12 mb-2">
            <forms #formNursery [formInfo]="formInfo" (filesSelected)="onFilesSelected($event)" class="form"></forms>
        </div>
    </div>
    <button class="btn green-btn" (click)="onEditNursery()" *ngIf="mode === 3">
        {{ "NURSERY_EDIT_COMPONENT_EDIT" | translate }}
    </button>
    <button class="btn green-btn ml-3" (click)="onOpenMap()" *ngIf="mode === 3">
        {{ "NURSERY_EDIT_COMPONENT_MAP" | translate }}
    </button>
    <button
        class="btn green-btn"
        [disabled]="!this.formComponent.form.valid"
        (click)="onSaveNursery()"
        *ngIf="mode === 1 || mode === 2"
    >
        {{ "NURSERY_EDIT_COMPONENT_SAVE" | translate }}
    </button>
    <!--<nursery-items #nurseryItems *ngIf="nursery" [nursery]="nursery" [mode]="mode"></nursery-items>-->

    <div class="position-absolute d-flex justify-content-center sphere-loading" *ngIf="sphereLoadingVisible">
        <span>{{ currentLoading | translate }}</span>
    </div>
</div>
